/*
 * @Author: 范朝阳
 * @Date: 2020-05-09 14:45:40
 * @LastEditTime: 2020-08-13 16:34:45
 * @LastEditors: 赵健
 * @Description: 字典表
 * @FilePath: \Develop2.0.0\src\enum\index.js
 */
// 性别
export const USER_SEX = {
  '1': '男',
  '2': '女'
}
// 组织架构-组织架构类型
export const ORGAN_TYPE = {
  '1': '集团',
  '2': '公司',
  '3': '部门',
  '4': '岗位'
}
// 组织架构- 组织架构性质
export const ORGAN_NATURE = {
  '0': '内部组织',
  '1': '承建商组织'
}
// 组织架构-角色
// 组织架构-角色 【角色类型】
export const ORGAN_ROLE_TYPE = {
  '1003501': '角色组',
  '1003502': '角色'
}
// 组织架构-角色 【角色性质】
export const ORGAN_ROLE_NATURE = {
  '1003511': '内部',
  '1003512': '承建商',
  '1003513': '不限'
}
// 组织架构-用户
// 组织架构-用户 【生效状态】
export const ORGAN_USER_STATUS = {
  '1': '启用',
  '0': '禁用'
}
// 检查项-管理
// 检查项-检查项类型
export const CHECKITEM_TYPE = {
  '1010501': '现场检查',
  '1010502': '工程验收',
  '1010503': '实测实量'
}
// 项目-项目类型
export const PROJECT_TYPE = {
  '1': '项目',
  '2': '分期',
  '3': '段标'
}

// 建材
export const MATERIAL_SOURCE = {
  '1053501': '本地新增',
  '1053502': '同步'
}

// 智慧劳务-入离场状态
export const EEGROUP_ENTRANCE_CODE = {
  '1075520': '待入场',
  '1075521': '已入场',
  '1075522': '已离场'
}
// 智慧劳务-入离场状态 初始化
export const EEGROUP_ENTRANCE_CODE2 = {
  '1075520': '待入场',
  '1075521': '已入场',
  '1075522': '已离场',
  '1075523': '初始化'
}

// 智慧劳务-人员工资状态
export const EMPLOYEE_SALARY_CODE = {
  '1085511': '全部',
  '1085512': '未生成',
  '1085513': '待发放',
  '1085514': '发放中',
  '1085515': '已发放',
  '1085516': '待核销',
  '1085517': '核销中',
  '1085518': '已核销'
}
// 智慧劳务-人员工资状态-色值
export const EMPLOYEE_SALARY_CODE_COLOR = [
  { code: '1085512', label: '未生成', color: '#333333' },
  { code: '1085513', label: '待发放', color: '#FF7F02' },
  { code: '1085514', label: '发放中', color: '#2B6FEF' },
  { code: '1085515', label: '已发放', color: '#57BB6E' },
  { code: '1085516', label: '待核销', color: '#FF7F02' },
  { code: '1085517', label: '核销中', color: '#2B6FEF' },
  { code: '1085518', label: '已核销', color: '#57BB6E' }
]
// 智慧劳务-审批状态
export const APPROVAL_STATUS = [
  { code: '1106511', label: '草稿', color: '#333333' },
  { code: '1106512', label: '已提交', color: '#57BB6E' },
  { code: '1106513', label: '审批中', color: '#2B6FEF' },
  { code: '1106514', label: '审批通过', color: '#57BB6E' },
  { code: '1106515', label: '审批拒绝', color: '#F45C5C' },
  { code: '1106516', label: '已作废', color: '#F8AD3B' },
  { code: '1106521', label: '不可执行', color: '#333333' },
  { code: '1106522', label: '待执行', color: '#FF7F02' },
  { code: '1106523', label: '执行通过', color: '#38BA72' },
  { code: '1106524', label: '执行退回', color: '#6672FB' }
  // { code: null, label: '-', color: '#333' }
]

// 模块类型
export const CATEGORY_CODE = {
  1: '智慧工程',
  2: '智慧劳务',
  3: '智慧建材'
}
// 设计大屏 组件

export const UNIT_LIST = [

]

// 智慧劳务-考勤状态
export const ATTENDANCE_RECORD_STATUS_CODE = [
  { code: '1080501', label: '正常', color: '#2B6FEF' },
  { code: '1080502', label: '异常', color: '#FF7F02' },
  { code: '1080503', label: '旷工', color: '#F45C5C' }
]
// 智慧劳务- 申诉类型
export const APPEAL_APPLY_CODE = [
  { code: '1080516', 'label': '异常申诉打卡', color: '#FF7F02' },
  { code: '1080517', 'label': '外勤申诉打卡', color: '#2B6FEF' },
  { code: '1080518', 'label': '旷工申诉打卡', color: '#F45C5C' }
]
// 智慧劳务- 入离职类型
export const DEPARTURE_CODE = [
  { code: '1077501', 'label': '入职', color: '#2B6FEF' },
  { code: '1077502', 'label': '离职', color: '#F45C5C' }
]
// 智慧劳务 - 入离场状态
export const ENTRY_LEAVE_STATUS_CODE = [
  { code: '1075551', 'label': '新入场', color: '#2B6FEF' },
  { code: '1075552', 'label': '已离场', color: '#F45C5C' },
  { code: '1075553', 'label': '正常', color: '#FF7F02' }
]
// 智慧劳务 - 性别
export const SEX_CODE = [
  { code: '1040531', 'label': '男' },
  { code: '1040532', 'label': '女' }
]
// 智慧劳务 - 品行记录 - 事件类型
export const EVENT_TYPE_CODE = [
  { code: 1119501, label: '寻衅斗殴' },
  { code: 1119502, label: '酗酒滋事' },
  { code: 1119503, label: '偷盗行为' },
  { code: 1119504, label: '恶意讨薪' },
  { code: 1119505, label: '破坏公共财物' },
  { code: 1119506, label: '违反安全规定' },
  { code: 1119507, label: '违反管理条例' },
  { code: 1119508, label: '其他' }
]
// 智慧劳务 - 品行记录 - 严重级别
export const SEVERITY_LEVEL_CODE = [
  { code: 1119521, label: '一般' },
  { code: 1119522, label: '严重' },
  { code: 1119523, label: '非常严重' }
]
// 智慧劳务 - 品行记录 - 奖励类型
export const REWARD_TYPE_CODE = [
  { code: 1120501, label: '优秀员工' },
  { code: 1120502, label: '杰出员工' },
  { code: 1120503, label: '十年员工' }
]
// 异步进度状态code
export const ASYNC_CODE = {
  '1109501': '等待开始',
  '1109502': '初始化完成',
  '1109503': '进行中',
  '1109504': '终止',
  '1109505': '正常结束'
}
// 名族
export const NATION_CODE = {
  1040571: '汉族',
  1040572: '满族',
  1040573: '蒙古族',
  1040574: '回族',
  1040575: '藏族',
  1040576: '维吾尔族',
  1040577: '苗族',
  1040578: '彝族',
  1040579: '壮族',
  1040580: '布依族',
  1040581: '侗族',
  1040582: '瑶族',
  1040583: '白族',
  1040584: '土家族',
  1040585: '哈尼族',
  1040586: '哈萨克族',
  1040587: '傣族',
  1040588: '黎族',
  1040589: '傈僳族',
  1040590: '佤族',
  1040591: '畲族',
  1040592: '高山族',
  1040593: '拉祜族',
  1040594: '水族',
  1040595: '东乡族',
  1040596: '纳西族',
  1040597: '景颇族',
  1040598: '柯尔克孜族',
  1040599: '土族',
  1040600: '达斡尔族',
  1040601: '仫佬族',
  1040602: '羌族',
  1040603: '布朗族',
  1040604: '撒拉族',
  1040605: '毛南族',
  1040606: '仡佬族',
  1040607: '锡伯族',
  1040608: '阿昌族',
  1040609: '普米族',
  1040610: '朝鲜族',
  1040611: '塔吉克族',
  1040612: '怒族',
  1040613: '乌孜别克族',
  1040614: '俄罗斯族',
  1040615: '鄂温克族',
  1040616: '德昂族',
  1040617: '保安族',
  1040618: '裕固族',
  1040619: '京族',
  1040620: '塔塔尔族',
  1040621: '独龙族',
  1040622: '鄂伦春族',
  1040623: '赫哲族',
  1040624: '门巴族',
  1040625: '珞巴族',
  1040626: '基诺族'
}
